import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { ImportedEmployment } from './imported-employment.interface';

export class ImportedEmploymentService {
   async getImportedEmployments(params?: LocationQuery) {
      const response = await http.get<PaginatedResponse<{ data: ImportedEmployment }>>(`/imported-employments`, { params });
      return response.data;
   }

   async getImportedEmployment() {
      throw Error('Method not implemented');
   }

   async postImportedEmployment() {
      throw Error('Method not implemented');
   }

   async putImportedEmployment(imported_employments: Array<ImportedEmployment>, params?: LocationQuery) {
      const response = await http.put<{
         imported_employments: Array<ImportedEmployment>;
      }>(`/imported-employments-batch`, { imported_employments }, { params });
      return response.data?.imported_employments || [];
   }

   async deleteImportedEmployment(id: number) {
      const response = await http.delete(`/imported-employments/${id}`);
      return response.data;
   }

   async getImportedEmploymentsCount() {
      const response = await http.get<number>(`/imported-employments-count`);
      return response.data;
   }
}
